import { useMemo } from "react";

type ValidationRule = {
  validate: () => boolean;
  errorMessage?: string;
};

type UseFormValidationConfig = {
  validationRules: ValidationRule[];
  dependencies: any[];
};

export const useFormValidation = (config: UseFormValidationConfig) => {
  const isReady = useMemo(() => {
    return config.validationRules.every((rule) => rule.validate());
  }, config.dependencies);

  return { isReady };
};
